import { useState, type ReactNode } from "react";
import { usePage } from "@inertiajs/react";
import { FormErrors } from "@/components/forms/form-errors";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

type FocusPanelProps = {
  trigger: string;
  title: string;
  description?: string;
  children: ReactNode;
  errorTargets?: Record<string, string>;
};

export function FocusPanel(props: FocusPanelProps) {
  const { auth } = usePage().props;
  return <FocusedEditor key={auth.account?.id} {...props} />;
}

function FocusedEditor({
  trigger,
  title,
  description,
  children,
  errorTargets = {},
}: FocusPanelProps) {
  const { errors } = usePage().props;
  const [open, setOpen] = useState(false);
  const [initialErrors, setInitialErrors] = useState(errors);
  return (
    <Sheet
      open={open}
      onOpenChange={(next) => {
        if (next) setInitialErrors(errors);
        setOpen(next);
      }}
    >
      <SheetTrigger render={<Button type="button" variant="outline" />}>
        {trigger}
      </SheetTrigger>
      <SheetContent
        keepMounted
        className="w-full! overflow-y-auto p-6 sm:max-w-xl!"
      >
        <SheetHeader className="p-0 pr-8">
          <SheetTitle>{title}</SheetTitle>
          {description && <SheetDescription>{description}</SheetDescription>}
        </SheetHeader>
        <div className="min-w-0 space-y-5">
          {errors !== initialErrors && (
            <FormErrors errors={errors || {}} targets={errorTargets} />
          )}
          {children}
        </div>
      </SheetContent>
    </Sheet>
  );
}
